import { get, sortBy } from 'lodash';
import moment from 'moment';

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const WORKING_TIME_START = moment()
  .utcOffset(7)
  .set({
    hour: 8,
    minute: 0,
    second: 0,
    millisecond: 0,
  })
  .unix();
export const WORKING_TIME_END = moment()
  .utcOffset(7)
  .set({
    hour: 21,
    minute: 30,
    second: 0,
    millisecond: 0,
  })
  .unix();

export const getOffersScoring = offers =>
  offers.filter(({ offerData: { recalAllow } }) => recalAllow);

export const getProOffer = offers =>
  offers.filter(({ offerData: { recalAllow } }) => !recalAllow);

export const getOffers = (offers, type) =>
  offers.filter(
    ({ offerData }) =>
      !get(offerData, 'productTypeCodeOffer', '').indexOf(type),
  );

export const getCLXOffers = (offers, prefixType) =>
  offers.filter(({ offerData }) =>
    get(offerData, 'productCodeOffer', '').startsWith(prefixType),
  );

export const getBestOffers = offers =>
  sortBy(offers, [off => off.offerData.maximalCreditAmount.amount])[
    offers.length - 1
  ];

export const getBestOfferForExitCustomer = (offers, offerTypes) => {
  const result = [];
  if (!offers) return result;
  offerTypes.forEach(type => {
    const list = getOffers(offers, type) || [];
    if (list.length) {
      const offer = getBestOffers(list);
      result.push(offer);
    }
  });
  return result;
};

export const getBestCLXOfferForExitCustomer = (offers, prefixTypes) => {
  const result = [];
  if (!offers) return result;
  prefixTypes.forEach(prefixType => {
    const list = getCLXOffers(offers, prefixType) || [];
    if (list.length) {
      const offer = getBestOffers(list);
      result.push(offer);
    }
  });
  return result;
};
